import type { CapabilityLevel } from '../Program/components/learning-lifecycle/teamCapability';
import type { IOrgMember } from './OrgMembersPage';

// A member's Capability figures on the Members table, from the backend
// (GET /v3/admin/capability/members): the same working as their own Capability
// tab, so the row and the panel it opens always agree.

export interface MemberCapabilitySummary {
  /** Their role; null when they hold none (no role, no capabilities). */
  roleName: string | null;
  /** The share of their role's assessed capabilities at Capable or better; null with none assessed. */
  percent: number | null;
  strongest: { name: string; level: CapabilityLevel } | null;
  /** With one capability assessed, it is their strongest and there is no weakest. */
  weakest: { name: string; level: CapabilityLevel } | null;
}

/** One member's capability. Null when they have no role or nothing has arrived for them. */
export const memberCapability = (member: IOrgMember): MemberCapabilitySummary | null =>
  member.capability
    ? {
        roleName: member.capability.roleName ?? null,
        percent: member.capability.percent,
        strongest: member.capability.strongest,
        weakest: member.capability.weakest
      }
    : null;
